<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col v-if="roles[0] != 'agent'" :md="8" :sm="24">
              <a-form-item label="经销商" prop="nickName">
                <a-input v-model="queryParam.nickName" placeholder="请输入经销商" allow-clear />
              </a-form-item>
            </a-col>

            <a-col v-if="roles[0] == 'agent'" :md="8" :sm="24">
              <a-form-item label="用户昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户昵称" allow-clear />
              </a-form-item>
            </a-col>
            <!--            <a-col :md="8" :sm="24">-->
            <!--              <a-form-item label="血压数据" prop="bloodPressure">-->
            <!--                <a-input v-model="queryParam.bloodPressure" placeholder="请输入血压数据" allow-clear/>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="血氧数据" prop="bloodOxygen">
                  <a-input v-model="queryParam.bloodOxygen" placeholder="请输入血氧数据" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="平均心率(次/分钟)" prop="ecgData">
                  <a-input v-model="queryParam.ecgData" placeholder="请输入平均心率(次/分钟)" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="HRV数值(ms)" prop="hrvData">
                  <a-input v-model="queryParam.hrvData" placeholder="请输入HRV数值(ms)" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="体温" prop="bodytemperatureData">
                  <a-input v-model="queryParam.bodytemperatureData" placeholder="请输入体温" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="压力值" prop="pressureData">
                  <a-input v-model="queryParam.pressureData" placeholder="请输入压力值" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="心率平均值(次/分)" prop="heartData">
                  <a-input v-model="queryParam.heartData" placeholder="请输入心率平均值(次/分)" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="血糖值(毫摩尔/升)" prop="bloodSugarData">
                  <a-input v-model="queryParam.bloodSugarData" placeholder="请输入血糖值(毫摩尔/升)" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button v-if="roles[0] == 'agent'" type="dashed" @click="$refs.ImportExcel.importExcelHandleOpen()">
          <a-icon type="import" />导入
        </a-button>
        <!--        <a-button v-if="roles[0]=='agent'" type="primary" @click="$refs.createForm.handleAdd()">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['joe:joe:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['joe:joe:remove']">-->
        <!--          <a-icon type="delete" />删除-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['joe:joe:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a
            v-if="roles.includes('agent') || roles.includes('admin')"
            @click="$refs.createForm.handleUpdate(record, undefined)"
          >
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['joe:joe:remove']" />
          <a
            v-if="roles[0] == 'agent' && record.types == '1'"
            @click="handleDelete(record)"
            v-hasPermi="['joe:joe:remove']"
          >
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <import-excel ref="ImportExcel" @ok="getList" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageJoe, listJoe, delJoe } from '@/api/joe/standard'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Joe',
  components: {
    CreateForm,
    ImportExcel,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        sysUserId: null,
        bloodPressure: null,
        bloodOxygen: null,
        ecgData: null,
        hrvData: null,
        bodytemperatureData: null,
        pressureData: null,
        heartData: null,
        bloodSugarData: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '经销商',
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '用户昵称',
          dataIndex: 'nicknames',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '是否默认',
          dataIndex: 'types',
          ellipsis: true,
          customRender: function (t) {
            if (t == 0) {
              return '是'
            } else {
              return '否'
            }
          },
          align: 'center',
        },
        {
          title: '血压数据',
          dataIndex: 'bloodPressure',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '血氧数据',
          dataIndex: 'bloodOxygen',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '平均心率(次/分钟)',
          dataIndex: 'ecgData',
          ellipsis: true,
          align: 'center',
        },
        {
          title: 'HRV数值(ms)',
          dataIndex: 'hrvData',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '体温',
          dataIndex: 'bodytemperatureData',
          ellipsis: true,
          align: 'center',
        },

        {
          title: '压力值',
          dataIndex: 'pressureData',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '心率平均值(次/分)',
          dataIndex: 'heartData',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '血糖值(毫摩尔/升)',
          dataIndex: 'bloodSugarData',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    roles() {
      return this.$store.getters.roles
    },
  },
  watch: {},
  methods: {
    /** 查询经销商设置身体标准值列表 */
    getList() {
      this.loading = true
      pageJoe(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        sysUserId: undefined,
        bloodPressure: undefined,
        bloodOxygen: undefined,
        ecgData: undefined,
        hrvData: undefined,
        bodytemperatureData: undefined,
        pressureData: undefined,
        heartData: undefined,
        bloodSugarData: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delJoe(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'joe/dealer-standard/export',
            {
              ...that.queryParam,
            },
            `经销商设置身体标准值_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
